module.exports = ChineseDistricts;